import React, { useCallback } from "react";
import { m as motion } from "../../shared/components/Motion";
import "./styles/ThemeButtons.css";
function ThemeButtons({
  storedDefaultThemes,
  activeTheme,
  applyTheme,
  setActiveTheme,
  handleDeleteCustomTheme,
  enableColors,
}) {
  const handleClickEvent = useCallback(
    (theme, index, isCustomTheme) => {
      if (index === 0 && theme.name === "Delete Selected Custom Theme") {
        handleDeleteCustomTheme();
      } else {
        applyTheme(theme.colors, index);
        setActiveTheme(index);
      }
    },
    [applyTheme, setActiveTheme, handleDeleteCustomTheme]
  );

  return (
    <motion.div className="themes_colors-container">
      {storedDefaultThemes.map(({ name, colors }, index) => {
        const isActive = activeTheme === index;
        const stylesClassName =
          index === 0 ? "themes_colors-button-clearThemes" : "";
        const isClearTheme = index === 0 && name === "Clear Themes";
        const isDeleteTheme =
          index === 0 && name === "Delete Selected Custom Theme";
        const headerBackground = colors.headerColor || colors.textColor;
        const background = colors.backgroundColor || colors.textColor;
        const isCustomTheme = name.includes("Custom");
        return (
          <motion.button
            title={name}
            type="button"
            key={index}
            onClick={() =>
              handleClickEvent({ name, colors }, index, isCustomTheme)
            }
            className={`themes_colors-button ${stylesClassName} ${
              isActive ? "themes_colors-button-active" : ""
            }`}
            whileHover={{ scale: 1.05 }} // Add hover effect
            whileTap={{ scale: 0.95 }} // Add press effect
          >
            <div
              className={`themes_colors-button-top ${
                isActive ? "themes_colors-button-top-active" : ""
              }`}
              style={{ background: headerBackground }}
            />
            {isClearTheme && <i className="bx bx-block"></i>}
            {isDeleteTheme && <i className="bx bx-trash"></i>}
            <div
              className={`themes_colors-button-bottom ${
                isActive ? "themes_colors-button-bottom-active" : ""
              }`}
              style={{ background }}
            />
          </motion.button>
        );
      })}
    </motion.div>
  );
}

export default ThemeButtons;
